import { instance, errorService } from '@/services/api'
import { dropdownAPIs, userAPIs } from '@/services/authConstantsV1'
import { socketEvents } from '@/services/config'
import {
  calculateGridHeight,
  customComparator,
  showNotification,
} from '@/services/calculate'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import SelectEditor from '@/components/DynamicComponents/Renderers/selectEditor'
import ActionRenderer from './GridRenderer/actionRendere'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  data: function() {
    return {
      count: 0,
      usersList: [],
      page: 0,
      pageSize: 0,
      isRefresh: false,
      loadUsers: false,
      loadRefresh: false,
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      gridOptions: null,
      columnDefs: null,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      defaultSortOrder: true,
      defaultSortedBy: 'name',
      width: '100%',
      height: '440px',
      loading: true,
      userId: null,
      filters: {},
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.userId = user.id
    this.loadingConfig()
  },
  mounted() {
    window.addEventListener('resize', this.getWindowSize)
    this.$socketHub.$on('message-received', this.messageReceived)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
    this.$socketHub.$off('message-received')
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['reset', 'apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.frameworkComponents = {
        roleEditor: SelectEditor,
        actionCellRenderer: ActionRenderer,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
      }
      this.columnDefs = [
        {
          headerName: 'Name',
          field: 'name',
          width: 500,
          sort: 'asc',
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Name',
        },
        {
          headerName: 'Email',
          field: 'email',
          width: 500,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Email',
        },
        {
          headerName: 'Role',
          field: 'role',
          cellEditor: 'roleEditor',
          cellEditorParams: {
            roles: this.getUserRoles(),
          },
          editable: params => {
            return params.data.id !== this.userId
          },
          width: 200,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Role',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    // Refresh Users
    refreshUsers() {
      this.loading = true
      this.loadRefresh = true
      this.usersList = []
      this.page = 0
      this.defaultSortedBy = 'name'
      this.defaultSortOrder = true
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'name',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getUsers(this.tableParams)
    },

    // Load Users
    getUsers(params) {
      params.api.sizeColumnsToFit()
      this.loading = true
      const request = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
      }
      const merged = { ...request, ...this.filters }
      instance
        .post(userAPIs.list, merged)
        .then(response => {
          this.tableParams = null
          this.usersList = _.get(response.data, 'result', [])
          this.count = response.data.totalCount ? response.data.totalCount : 0
          this.height = calculateGridHeight(
            'userTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loading = false
          this.loadRefresh = false
          this.tableParams = params
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.usersList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'name'
        this.defaultSortOrder = true
      }
      this.getUsers(this.tableParams)
    },

    // Sync Users
    syncUsers() {
      this.loadUsers = true
      instance
        .put(userAPIs.sync)
        .then(response => {
          this.$notification.info({
            message: 'Sync Users',
            description: (
              <div>
                <div>
                  Your request for sync users will be processed shortly.
                </div>
                <div>You will be notified once the request is completed</div>
              </div>
            ),
            duration: 200,
          })
          this.loadUsers = false
          setTimeout(() => {
            this.$notification.destroy()
          }, 2000)
        })
        .catch(error => {
          this.loadUsers = false
          errorService(error)
        })
    },

    getUserRoles() {
      return instance
        .post(dropdownAPIs.dropdown, { role: 0 })
        .then(response => {
          return _.get(response.data, 'result.role', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'userTable',
        this.count > this.pageSize,
      )
      this.gridOptions.api.sizeColumnsToFit()
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.usersList = []
      this.selectedRowKeys = []
      this.getUsers(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      this.usersList = []
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.page = 0
      this.getUsers(this.tableParams)
    },

    // Socket listen
    messageReceived: function(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.usersSynced) {
        if (data.Status === 'SUCCESS') {
          this.$notification.success({
            message: 'Sync Users',
            description: h => (
              <div>
                <div> Total Synced Users: {data.Result.Synced_Users} </div>
                <div> {data.Result.Message} </div>
              </div>
            ),
            duration: 200,
          })
        } else {
          showNotification('error', 'Sync Users', data.Result.Message)
        }
      }
    },
  },
}
